/*
 * Modules
 */

import './modules/countdown.js';
import './modules/videos.js';
import './modules/tabs.js';
import './modules/sticky.js';
import './modules/parallaxScroll.js';
import './modules/switchBgColor.js';
import './modules/stickyStickyNavActiveClass.js';
import './modules/switchNavActiveClass.js';
import './modules/scrollIntoViewTouchDevice.js';
import './modules/showDropdown.js';
import './modules/firefoxFontChange.js';
import './modules/slider.js';
import './modules/lightbox.js';
import './modules/accordion.js';
import './modules/dynamic-functionality.js';
